import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route } from 'react-router-dom'
import { Provider } from "react-redux"
import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers/root_reducer'
import Modal from '../common/components/modal_dialog/modal_wrapper_component'

let store = createStore(
  rootReducer,
  applyMiddleware(thunk)
)

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.modal-portal')
  ReactDOM.render(
    <BrowserRouter>
      <Provider store={store}>
        <Route path='/:locale?/areas' render={(props) => <Modal {...props} />} />
      </Provider>
    </BrowserRouter>,
    root
  )
})
